import { resolveErrorMessage } from '~/utils/i18n/errorCode';
import type { ErrorTranslator } from '~/utils/i18n/errorCode';

// Display text for an API error on screens that render it inline (form errors, banners):
// the translated `errors.<code>` message when the server attached a known code, else the
// screen's existing fallback text. Control flow must keep comparing the raw English
// `statusMessage` — this only changes what the user reads.
//
// `$i18n` is captured at setup (like useErrorHandler) because callers invoke `toErrorMessage`
// from async catch / mutation `onError` callbacks where useI18n() can't resolve an instance;
// `t` is read per call, so a locale switch between calls is honoured.
export const useErrorMessage = () => {
  const { $i18n } = useNuxtApp();

  const translator: ErrorTranslator = {
    t: (key, params) => $i18n.t(key, params ?? {}),
    te: (key) => $i18n.te(key),
  };

  const toErrorMessage = (error: unknown, fallback: string): string => resolveErrorMessage(error, translator, fallback);

  return {
    toErrorMessage,
  };
};
